import { useMemo } from "react";
import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { Ico } from "../../../components/icons/icons.jsx";
import { ModalShellHeader } from "../../../components/modal/ModalShellHeader.jsx";
import { buildModalShellTokens } from "../../../components/modal/modalShellTheme.js";
import { COMMAND_TYPES } from "../commandUtils.js";

const TYPE_ICONS = {
  chip: Ico.chip,
  device: Ico.device,
  terminal: Ico.terminal,
};

export function CommandBuilderPlaceholderModal({ open, onClose, commandType }) {
  const { c, dark, accentHex: A } = useThemeSlice();
  const ap = useMemo(() => buildModalShellTokens(dark, c, A), [dark, c, A]);

  const typeMeta = COMMAND_TYPES.find((t) => t.id === commandType);
  if (!open || !typeMeta) return null;

  return (
    <>
      <div
        role="presentation"
        onClick={onClose}
        style={{ position: "fixed", inset: 0, zIndex: 70, background: ap.overlay, backdropFilter: "blur(8px)" }}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="command-placeholder-modal-title"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "min(640px, calc(100vw - 32px))",
          minHeight: 320,
          display: "flex",
          flexDirection: "column",
          background: ap.cardGradient,
          border: `1px solid ${ap.cardBorder}`,
          borderRadius: 16,
          zIndex: 71,
          boxShadow: ap.cardShadowLg,
          overflow: "hidden",
        }}
      >
        <ModalShellHeader
          title={`New ${typeMeta.label.toLowerCase()}`}
          titleId="command-placeholder-modal-title"
          subtitle={typeMeta.description}
          icon={TYPE_ICONS[typeMeta.icon] ?? Ico.commands}
          onClose={onClose}
          closeLabel="Close command builder"
          dark={dark}
          c={c}
          A={A}
          ap={ap}
        />

        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px 32px",
            textAlign: "center",
            gap: 12,
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 14,
              background: `${A}12`,
              border: `1px solid ${A}28`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: A,
            }}
          >
            {TYPE_ICONS[typeMeta.icon] ?? Ico.commands}
          </div>
          <p style={{ margin: 0, fontSize: 15, fontWeight: 700, color: c.text }}>Coming soon</p>
          <p style={{ margin: 0, fontSize: 13, color: c.sub, maxWidth: 360, lineHeight: 1.55 }}>
            The {typeMeta.label.toLowerCase()} builder is not available yet.
          </p>
        </div>
      </div>
    </>
  );
}
